/**
 * Helper to check if option is selected in checkedOptions
 * @param {array} optionsArray
 * @param {string} key
 * @returns {boolean}
 */
const isOptionChecked = (optionsArray, key) =>
    (optionsArray || []).some((item) => item.name === key);

export default isOptionChecked;